<template>
  <div
    class="relative aspect-square w-full"
    :class="[perspectives.length === 1 && 'text-on-primary-container']"
  >
    <div
      v-if="isAMatch"
      class="absolute top-0 left-0 z-0 h-full w-full scale-110"
      :class="[!disableAnimation && 'animate-rotate']"
    >
      <BaseShape
        shape="sunny"
        class="text-primary"
        :class="[!disableAnimation && 'animate-bouncy-spin']"
      />
    </div>
    <PerspectiveShape
      v-else-if="perspectives.length === 1"
      :perspective="perspectives[0]!"
      :allPerspectives="allPerspectives"
    />
    <div v-else-if="perspectives.length > 1" class="relative flex h-full w-full">
      <BaseShape shape="sunny" class="text-primary scale-120" />
    </div>
    <!-- <div v-else-if="perspectives.length > 1" class="relative flex h-full w-full">
      <div
        v-for="(perspective, index) in perspectives"
        :key="perspective.key"
        class="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"
        :style="{ width: `${100 - index * 30}%`, height: `${100 - index * 30}%` }"
      >
        <PerspectiveShape :perspective="perspective" :allPerspectives="allPerspectives" />
      </div>
    </div> -->
  </div>
</template>
<script lang="ts" setup>
  import { computed } from 'vue'
  import BaseShape from '../../base/shapes/BaseShape.vue'
  import type { Perspective } from '@/core/models/perspective.ts'
  import PerspectiveShape from './PerspectiveShape.vue'

  const props = defineProps<{
    perspectives: Perspective[]
    allPerspectives: ReadonlyArray<Perspective>
    disableAnimation?: boolean
  }>()

  const isAMatch = computed(() => {
    return props.perspectives.length === props.allPerspectives.length
  })
</script>
